module.exports = __webpack_public_path__ + "img/tgzq.8e651335.png";